var exports = {
  "X": "Scroller.module__scroller___eTNhaD",
};

module.exports = exports;
